import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'data-error',
    templateUrl: './dataError.component.html',
    standalone: false
})
export class DataErrorComponent {
    @Input() public errorMessage: string;
    @Output() public onRequestRefresh = new EventEmitter<void>();

    public refreshRequested(event): void {
        if (event) event.stopPropagation();
        this.onRequestRefresh.emit();
    }
}